export const agencyUserData = obj => ({
    type: 'AGENCY_USER_DATA',
    obj
})